import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';


function IconTrader(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20">
        <path fill="none" d="M0 0h20v20H0z"/>
        <path fill={props.htmlColor || '#000'} d="M10.4 8.4A2.4 2.4 0 1 0 8 10.8a2.407 2.407 0 0 0 2.4-2.4zM8 9.2a.8.8 0 1 1 .8-.8.8.8 0 0 1-.8.8zm5.2 1.6a1.6 1.6 0 1 0-1.6-1.6 1.594 1.594 0 0 0 1.6 1.6zM9.99 2.01a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM5.07 14.1A5.451 5.451 0 0 1 8 13.21c.056 0 .12.008.184.008a3.86 3.86 0 0 1 1.04-1.488A7.24 7.24 0 0 0 8 11.6a7.151 7.151 0 0 0-3.784 1.144A6.307 6.307 0 0 1 3.59 10a6.4 6.4 0 1 1 12.2 2.7 5.632 5.632 0 0 0-2.59-.7c-1.216 0-3.6.648-3.6 2.16v2.224A6.348 6.348 0 0 1 5.07 14.1z"/>
      </svg>
    </SvgIcon>
  );
}

export default IconTrader;